import React from "react";
import Card from "@mui/joy/Card";
import CardCover from "@mui/joy/CardCover";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

const ListVideo = ({ dataVideoClip, onChangeVideo }) => {
    return (
        <div className="list-video">
            {dataVideoClip.items.map((itemVC) => {
                return (
                    <Card
                        key={itemVC.vc_id}
                        sx={{
                            minHeight: "172px",
                            width: ["100%", 250],
                            cursor: "pointer",
                        }}
                        onClick={() => onChangeVideo(itemVC.vc_link)}
                    >
                        <CardCover>
                            <img
                                src={itemVC.vc_hinhanh}
                                srcSet={itemVC.vc_hinhanh}
                                loading="lazy"
                                alt=""
                            />
                        </CardCover>
                        <CardCover
                            sx={{
                                background:
                                    "linear-gradient(to top, rgba(0,0,0,0.3), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0) 300px)",
                            }}
                        />
                        <CardCover sx={{ justifyContent: "center" }}>
                            <Typography
                                startDecorator={
                                    <PlayCircleOutlineIcon
                                        sx={{ fontSize: 40 }}
                                    />
                                }
                                textColor="neutral.300"
                            ></Typography>
                        </CardCover>
                        <CardContent
                            sx={{
                                justifyContent: "flex-end",
                            }}
                        >
                            <Typography
                                level="h2"
                                fontSize="lg"
                                textColor="#fff"
                                mb={1}
                            >
                                {itemVC.vc_tieude.substring(0, 70) + "..."}
                            </Typography>
                        </CardContent>
                    </Card>
                );
            })}
        </div>
    );
};

export default React.memo(ListVideo);
